import styled, { css } from 'styled-components/macro';
import { Z_INDEX } from '@yme/tokens/zindex';
const DEFAULT_PARAMS = css `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
// Styles for wrapper image component
export const PreviewImageStyled = styled.div `
  ${DEFAULT_PARAMS}

  width: 100%;
  overflow: hidden;

  display: ${({ isShowImagePreview }) => (isShowImagePreview ? 'block' : 'none')};
`;
// Styles for button - play video
export const VPlayButtonStyled = styled.div `
  ${DEFAULT_PARAMS}

  display: flex;
  text-align: center;
  margin: 0 auto;
  align-items: center;
  place-content: center;

  z-index: ${Z_INDEX.level1};

  & > span > svg {
    &:hover {
      cursor: pointer;

      path {
        fill-opacity: 0.9;
      }
    }
  }
`;
